export const FINISH_TUTORIAL_V2 = 'portal_compras/tutorial/FINISH_TUTORIAL_V2'
export const SHOW_REQUEST_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/SHOW_REQUEST_TUTORIAL_BANNER_V2'
export const SHOW_APPROVER_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/SHOW_APPROVER_TUTORIAL_BANNER'
export const CHECK_TUTORIAL_BANNER_V2 = 'portal_compras/tutorial/CHECK_TUTORIAL_BANNER_V2'
